import { useContext } from 'react'
import { ChatContext, type ChatContextValue } from '../contexts/ChatContextBase'

/**
 * チャットコンテキストを使用するカスタムフック
 */
export function useChat(): ChatContextValue {
  const context = useContext(ChatContext)
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider')
  }
  return context
}
